import React from 'react'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import './UserList.css'

const UserListUI = ({context, userList,
    // modes
    selectedCount,
    // event handlers
    onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick, onRowClick}) =>
  <div className='su_usrs'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick }
        />
      }
      right={<span />}
    />

    <LRTableBodyUI>
      {
        userList.map((user, i) =>
          <UserRowUI key={i} context={context} user={user} onRowClick={onRowClick} />
        )
      }
    </LRTableBodyUI>
  </div>

  const UserRowUI = ({context, user, onRowClick}) =>
    <LRTableRowUI
      context={context}
      left={<RowLeftUI context={context} user={user} onRowClick={onRowClick} />}
      right={<RowRightUI user={user} />}
    />

  const RowLeftUI = ({context, user, onRowClick}) =>
    <div className='g_flex_h'>
      {
        context.permissions.includes('su_manage') &&
        <input type="checkbox" className={`checkbox ${user.owner ? 'owner' : ''}`}
          checked={user.selected || false} onChange={() => {}}
          onClick={context.permissions.includes('su_manage') ? onRowClick : null}
          data-row-id={user.userId}
        />
      }
      <div className='g_flex_v g_m_left_50'>
        <div className='g_flex_h name'>
          <b>{user.addressableName}</b>
          {
            user.userId === context.session.userId &&
            <div className='self'></div>
          }
        </div>
        <span className='g_muted'>
          {user.email}
        </span>
      </div>
    </div>

  const RowRightUI = ({user}) =>
    <div className='g_flex_h'>
      <span className='g_muted'>
        {user.roleName}
      </span>
    </div>

  const ActionLeftUI = ({context, selectedCount, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick}) =>
    <React.Fragment>
      {
        selectedCount === 0 &&
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          {
            context.permissions.includes('su_manage') &&
            <IconButtonUI icon='icon-user-plus' onClick={onCreateClick} />
          }
        </div>
      }
      {
        selectedCount > 0 &&
        <div className='action g_flex_h'>
          <IconButtonUI icon='icon-pencil' onClick={onUpdateClick} />
          <IconButtonUI icon='icon-trash-o' onClick={onDeleteClick} />
        </div>
      }
    </React.Fragment>

export default UserListUI
